import React, {useState} from 'react';
import Modal, {ModalBody, ModalHeader} from "../../Modal";
import Button from "../../UI/Button";
import {SearchIconSubmitDoc} from "../../../Assets/svg";

const AddNewGroupModal = ({isOpen, setIsOpen, onSubmit}) => {

  const [groupName, setGroupName] = useState()

  return (
    <Modal
      isOpen={isOpen}
      modalCallback={setIsOpen}
    >
      <ModalHeader title={'افزودن گروه'}/>
      <ModalBody>

        <div className={"m-3 my-5 d-flex justify-content-center"}>
          <div className={"position-relative input__label width__210"}>
            <label htmlFor="documentNumber">گروه </label>
            <input
              placeholder={`عنوان را وارد کنید`}
              style={{padding:'15px 5px'}}
              name="documentNumber"
              value={groupName}
              onChange={e => setGroupName(e.target.value)}
            />
          </div>

        </div>

        <div className={'m-3 d-flex justify-content-center'}>

          <Button
            onClick={() => onSubmit(groupName)}
          > ثبت</Button>
          <Button color={'btn-red'}
                  onClick={() => setIsOpen({isOpen: false})}
          > انصراف</Button>

        </div>
      </ModalBody>
    </Modal>
  );
};

export default AddNewGroupModal;
